import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import { createClassName } from 'utils/createClassName';

import './linkControlStyles.scss';

type Props = {
  to: string;
  newTab?: boolean;
  local?: boolean;
  navigation?: boolean;
};

export const LinkControlComponent: React.FC<Props> = (props) => {
  const { to, newTab, local, navigation, children } = props;

  const className = createClassName('linkControl')();

  if (navigation) {
    return (
      <NavLink className={className} to={to}>
        {children}
      </NavLink>
    );
  }

  if (local) {
    return (
      <Link className={className} to={to}>
        {children}
      </Link>
    );
  }

  if (newTab) {
    return (
      <a
        href={to}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <a href={to} className={className}>
      {children}
    </a>
  );
};
